import AiStatusBadge from './AiStatusBadge.jsx'
export default AiStatusBadge 